module.exports = __webpack_public_path__ + "media/images/RemoveIcon-e41277e1b77c3648a848c1395f995ab4.png";